import {
  MakerIndexResponse,
  MakerWithCategoriesResponse,
} from "@/web-client/api";
import { FC } from "react";
import SimpleSlideshow from "@/components/SimpleSlideshow";
import MakerIdentity from "@/features/maker/components/MakerIdentity";

interface Props {
  maker: MakerIndexResponse | MakerWithCategoriesResponse;
}

// 契約済みで、メインビジュアルが設定されていること前提のコンポーネント
const MakerMainVisual: FC<Props> = ({ maker }): JSX.Element => {
  return (
    <header className="grid laptop:grid-cols-10 laptop:aspect-5/2 max-h-[64vh] w-full">
      <div className="flex flex-col justify-center py-32 items-center laptop:p-24 laptop:bg-white laptop:col-span-1 laptop:col-span-4">
        <div className="laptop:w-[50%] laptop:max-w-[320px] small:max-w-[200px] small:w-full">
          <MakerIdentity maker={maker} />
        </div>
      </div>
      <div className="relative small:aspect-5/2 small:col-span-full small:row-span-full laptop:col-start-5 laptop:col-end-11">
        <SimpleSlideshow
          imageUrls={maker.visual_images.map(
            (image) => image.upload_image.urls.original,
          )}
          wrapperClassName="w-full h-full"
        />
      </div>
    </header>
  );
};
export default MakerMainVisual;
